module.exports = __webpack_public_path__ + "static/UnifyHeroMobile-f2638be7a616d16790571a10f7a43ff2.svg";